import { Storage } from 'aws-amplify'

export const getFileURL = async key => {
  const url = await Storage.get(key)
  return url
}
